import * as DropdownMenuPrimitive from 'zeego/dropdown-menu';
import React from 'react';
import { Platform } from 'react-native';

// Direct exports of primitives - no wrapping needed for native menus
// Zeego will automatically use the native menu components on iOS/Android
const {
  Root,
  Trigger,
  Portal,
  Item,
  ItemTitle,
  ItemIcon,
  CheckboxItem,
  RadioItem,
  Label,
  Separator,
  ItemIndicator,
  Arrow,
  Sub,
  SubTrigger,
  SubContent,
  RadioGroup,
  create,
} = DropdownMenuPrimitive;

// Keep web menus inside a containing modal's focus trap when a host is supplied.
// Native menus must keep Zeego's primitive for its child discovery.
function WebContent({ portalContainer, ...props }) {
  const RadixMenu = require('@radix-ui/react-dropdown-menu');
  return <RadixMenu.Portal container={portalContainer}><RadixMenu.Content {...props} /></RadixMenu.Portal>;
}
const Content = Platform.OS === 'web' ? WebContent : DropdownMenuPrimitive.Content;

const DropdownOverlayHost = DropdownMenuPrimitive.DropdownOverlayHost || null;
const DropdownBackground = DropdownMenuPrimitive.DropdownBackground || React.Fragment;

export {
  Root,
  Trigger,
  Portal,
  Content,
  Item,
  ItemTitle,
  ItemIcon,
  CheckboxItem,
  RadioItem,
  Label,
  Separator,
  ItemIndicator,
  Arrow,
  Sub,
  SubTrigger,
  SubContent,
  RadioGroup,
  DropdownOverlayHost,
  DropdownBackground,
  create
};
